import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { BaseRequestService } from 'src/app/_services/base.service';
import { MyToastrService } from 'src/app/_services/toastr.service';
import { CommonService } from 'src/app/_services/common.services';
declare var require: any;

@Component({
  selector: 'app-custom-table',
  templateUrl: './custom-table.component.html',
  styleUrls: ['./custom-table.component.scss']
})

export class CustomTableComponent implements OnInit {
  displayedColumns: any = [];
  dataSource = new MatTableDataSource;
  validationData: any;
  Objectkeys = Object.keys;
  validationKey: any = [];
  currentRecon: any = {};
  etlProcess: any = "";
  execNumber: any = "";
  entity: any = "";
  company: any = "";
  glPeriod: any = "";
  processList: any;
  companyPeriodList: any = [];
  glBalanceSheetData: any = [];
  glBalanceSheetKey: any = [];
  loading: boolean = false;

  constructor(private baseService: BaseRequestService, private toast: MyToastrService, private cs: CommonService) {
    this.currentRecon = this.cs.currentReconProcess;
  }

  ngOnInit() {
    setTimeout(() => {
      this.getGLBalanceSheet();
      this.getProcessDetails();
    }, 500);
  }

  getCompanyPeriod() {
    let params: any = {};
    params = {
      reconId: this.currentRecon.reconId,
      entity: this.entity,
      etl_process: this.etlProcess,
      exec_number: this.execNumber
    }
    this.baseService.doRequest('/api/recons/getCompanyPeriod', 'post', params).subscribe((result: any) => {
      if(result.status === true) {
        this.companyPeriodList = result.data;
      } else {
        this.toast.sToast('error', result.message);
      }
    })
  }

  getProcessDetails() {
    let params: any = {};
    params = {
      reconId: this.currentRecon.reconId
    }
    this.baseService.doRequest('api/recons/getEtlProcessExecutionNumber', 'post', params).subscribe((result: any) => {
      if(result.status === true) {
        this.processList = result.data;
      } else {
        this.toast.sToast('error', result.message);
      }
    })
  }

  getGLBalanceSheet() {
    let params: any = {};
    params = {
      reconId: this.currentRecon.reconId,
      stmtdate: "",
      period: this.glPeriod ? this.glPeriod : "",
      entity: this.entity ? this.entity : "",
      etl_process: this.etlProcess ? this.etlProcess : "",
      exec_number: this.execNumber ? this.execNumber : ""
    }
    this.loading = true;
    this.baseService.doRequest('api/recons/getGlBalanceSheet', 'post', params).subscribe((result: any) => {
      if(result.status === true) {
        this.Objectkeys(result.data).map((ele: any) => this.glBalanceSheetKey.push(ele));
        this.glBalanceSheetData = result.data;
        this.loading = false;
        this.glBalanceSheetKey.map((ele: any) => {
          this.displayedColumns[ele] = this.Objectkeys(result.data[ele][0]);
        });
      } else {
        this.toast.sToast('error', result.message);
        this.loading = false;
      }
    });
  }

}